/**
 * Admin → Directories.
 *
 * One tab for imported reference data, with the two halves of the job as sub-tabs: the records
 * themselves, and the feeds that fill them. They were separate top-level tabs, which put "where
 * does this data come from" and "what is in it" in different places despite being the same
 * subject — and made the Data feeds tab, which is touched once per feed and then rarely, as
 * prominent as the one people actually use.
 *
 * Sub-tabs rather than a merged page, and held in component state rather than the URL, following
 * Field Builder's Layout / Auto-fill rules split (AdminFieldBuilder.jsx). The old
 * /admin/feeds route stays as a redirect, the same courtesy the Conflicts consolidation kept for
 * old bookmarks.
 *
 * Records is the default because it is the everyday view; when a directory is empty it points at
 * Feeds itself, so the setup path is never a dead end.
 *
 * People is the firm's own directory, the index of everyone with an account that the conflict
 * request's "Copy others" box searches. It is a third kind of reference data, from Entra rather
 * than a feed, and it lives here because "who is at the firm" is the same question as the others.
 */

import { useState } from 'react';
import AdminFeeds from './AdminFeeds';
import DirectoryRecords from './DirectoryRecords';
import DirectoryPeople from './DirectoryPeople';

const TABS = [
  ['records', 'Records'],
  ['feeds', 'Feeds'],
  ['people', 'People'],
];

export default function AdminDirectories() {
  const [tab, setTab] = useState('records');

  const tabButtonClass = (id) =>
    id === tab
      ? 'border-b-2 border-firm-700 pb-2 text-sm font-semibold text-firm-700 dark:border-firm-100 dark:text-firm-100'
      : 'border-b-2 border-transparent pb-2 text-sm font-medium text-slate-500 hover:text-firm-700 dark:text-slate-400 dark:hover:text-firm-100';

  return (
    <div className="space-y-4">
      <div className="flex gap-4 border-b border-slate-200 dark:border-slate-700">
        {TABS.map(([id, label]) => (
          <button key={id} type="button" onClick={() => setTab(id)} className={tabButtonClass(id)}>
            {label}
          </button>
        ))}
      </div>

      {tab === 'feeds' ? (
        <AdminFeeds />
      ) : tab === 'people' ? (
        <DirectoryPeople />
      ) : (
        <DirectoryRecords onConfigure={() => setTab('feeds')} />
      )}
    </div>
  );
}
